import { Base } from '@studiometa/js-toolkit';
import Hotspot from './Hotspot.js';

/**
 * Hotspot - Affiche des éléments à des moments spécifiques de la vidéo
 */
export default class HotspotGroup extends Base {
  isHide = true;
  /**
   * Component Configuration
   */
  static config = {
    name: 'HotspotGroup',
    components: {
      Hotspot,
    },
    options: {
      position: Number,
    },
  };

  /**
   * When clicking on hotspot go to label on timeline
   * @param {object} props Props
   * @param {object} props.args elements.
   * @returns {void}
   */
  onHotspotClickBtn({ args }) {
    this.$parent.goToLabel(args[0]);
  }

  /**
   *
   */
  enableGroup() {
    this.$el.classList.remove('pointer-events-none');
  }

  /**
   *
   */
  disableGroup() {
    this.$el.classList.add('pointer-events-none');
  }

  /**
   * @returns {number}
   */
  get position() {
    return this.$options.position;
  }

  /**
   * @returns {number}
   */
  get hotspotsCount() {
    return this.$children.Hotspot.length;
  }

  /**
   * @returns {Array}
   */
  get hotspotsBtn() {
    return this.$children.Hotspot.map((hotspot) => hotspot.$refs.btn);
  }

  /**
   * @returns {Array}
   */
  get hotspotsContent() {
    return this.$children.Hotspot.map((hotspot) => hotspot.$refs.content);
  }
}
